import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_rail-academy-preview/artifacts/9cc398my_UKTDA%20transparent.png";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200"
      data-testid="site-header"
    >
      <div className="container-rail flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
          <img
            src={LOGO_URL}
            alt="UKTDA logo"
            className="h-11 w-11 md:h-12 md:w-12 object-contain"
            width="48"
            height="48"
          />
          <span className="flex flex-col leading-tight">
            <span className="font-display font-extrabold text-navy text-lg md:text-xl tracking-tight"></span>
            <span className="label-eyebrow text-[9.5px] md:text-[10px] text-slate-500 mt-0.5">Railway Training &amp; Competence</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `px-3 py-2 text-[13.5px] font-medium transition-colors rounded-md ${
                  isActive
                    ? "text-navy bg-slate-100"
                    : "text-slate-600 hover:text-navy hover:bg-slate-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-cta-contact"
            className="inline-flex items-center gap-2 bg-safety hover:bg-[#e66e00] text-white font-semibold text-sm px-4 py-2.5 rounded-md transition-colors"
          >
            Contact us
          </Link>
        </div>

        <button
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-navy"
          data-testid="header-mobile-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <nav className="container-rail py-4 flex flex-col gap-1" aria-label="Mobile">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.to.replace(/\//g, "") || "home"}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-base rounded-md ${
                    isActive ? "bg-slate-100 text-navy font-semibold" : "text-slate-700"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-cta-contact"
              className="mt-2 text-center bg-safety text-white font-semibold py-3 rounded-md"
            >
              Contact us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
